import React from "react";
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import novaPoshta from '../images/nova_poshta.svg';

const useStyles = makeStyles(theme => ({
    card: {
        padding: '32px',
        display: 'flex',
        justifyContent: 'space-between',
        gap: '16px',
        alignItems: 'center',

        [theme.breakpoints.down('sm')]: {
            padding: '16px',
            flexDirection: 'column',
        },
    },
    item: {
        width: 'calc((100% - 16px)/2)',
        color: 'rgb(28, 42, 83)',

        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
    },
    p400: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px',
        color: 'rgb(28, 42, 83)',

        '& span': {
            color: 'rgb(255, 190, 0)'
        }
    },
    p500: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '22px'
    },
    strong: {
        fontWeight: 700,
        fontSize: '14px',
        color: 'rgb(28, 42, 83)',
    }
}));

const NovaPoshtaCard = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={`dashboard-card ${classes.card}`} style={{ flexDirection: 'column', gap: 'unset', alignItems: 'flex-start' }}>
            <p className={classes.p400} style={{ margin: '0 0 8px 0' }}>
                {t("common:dropshipping_how_successful")}
            </p>
            <strong className={classes.strong} style={{ margin: '0 0 16px 0' }}>
                {t("common:how_to_connect_sender")}
            </strong>
            <p className={classes.p400} style={{ margin: '0 0 8px 0' }}>
                {t("common:make_agreement")}
            </p>
            <p className={classes.p400} style={{ margin: '0 0 8px 0' }}>
                {t("common:provide_info")}
            </p>
            <p className={classes.p400} style={{ margin: '0 0 34px 0' }}>
                {t("common:fname_lname_info")}
            </p>
            <p className={classes.p400}>
                {t("common:api_key_np")}
            </p>
            <img
                src={novaPoshta}
                alt='Daniparts'
                style={{ margin: '8px 0 0 0' }}
            />
        </div>
    );
}

export default NovaPoshtaCard;